var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogoMobile = function SvgLogoMobile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo/Favicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/Favicon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7989899,-5.80868686e-13 L39.7989899,39.5979797 L20,19.7989899 L39.7989899,-5.80868686e-13 Z",
    id: "Combined-Shape",
    fill: "#2CB0C7",
    transform: "translate(29.899495, 19.798990) scale(-1, 1) translate(-29.899495, -19.798990) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.125,1.72258006 L26.8485174,19.9999892 L45.125,38.2764719 L45.125,1.72258006 Z",
    id: "Combined-Shape-Copy",
    stroke: "#000000",
    strokeWidth: 1.2,
    transform: "translate(36.000000, 20.000000) scale(-1, 1) translate(-36.000000, -20.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FD4D00",
    cx: 9.5,
    cy: 20.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#000000",
    strokeWidth: 1.2,
    cx: 15.5,
    cy: 20.5,
    r: 8.9
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoMobile);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYzLjEgKDkyNDUyKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5Mb2dvL0Zhdmljb248L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iTG9nby9GYXZpY29uIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCA0LjAwMDAwMCkiPgogICAgICAgICAgICA8cGF0aCBkPSJNMzkuNzk4OTg5OSwtNS44MDg2ODY4NmUtMTMgTDM5Ljc5ODk4OTksMzkuNTk3OTc5NyBMMjAsMTkuNzk4OTg5OSBMMzkuNzk4OTg5OSwtNS44MDg2ODY4NmUtMTMgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjMkNCMEM3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS44OTk0OTUsIDE5Ljc5ODk5MCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMjkuODk5NDk1LCAtMTkuNzk4OTkwKSAiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTQ1LjEyNSwxLjcyMjU4MDA2IEwyNi44NDg1MTc0LDE5Ljk5OTk4OTIgTDQ1LjEyNSwzOC4yNzY0NzE5IEw0NS4xMjUsMS43MjI1ODAwNiBaIiBpZD0iQ29tYmluZWQtU2hhcGUtQ29weSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYuMDAwMDAwLCAyMC4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTM2LjAwMDAwMCwgLTIwLjAwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiNGRDREMDAiIGN4PSI5LjUiIGN5PSIyMC41IiByPSI5LjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLUNvcHkiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjIiIGN4PSIxNS41IiBjeT0iMjAuNSIgcj0iOC45Ij48L2NpcmNsZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";